/** Single place that knows how to talk to the Worker. */

export const API_BASE = import.meta.env.VITE_API_URL ?? '/api';

const CHAVE_TOKEN = 'sala.token';

export const guardarToken = (token: string) => localStorage.setItem(CHAVE_TOKEN, token);
export const lerToken = () => localStorage.getItem(CHAVE_TOKEN);
export const limparToken = () => localStorage.removeItem(CHAVE_TOKEN);

export class ErroApi extends Error {
  constructor(public status: number, mensagem: string) {
    super(mensagem);
  }
}

/** Set by the auth provider so a 401 anywhere logs the user out once. */
let aoExpirar: (() => void) | null = null;
export const definirCallbackExpiracao = (fn: () => void) => { aoExpirar = fn; };

export async function pedir<T>(
  caminho: string,
  opcoes: RequestInit = {},
): Promise<T> {
  const token = lerToken();
  const headers = new Headers(opcoes.headers);
  headers.set('Content-Type', 'application/json');
  if (token) headers.set('Authorization', `Bearer ${token}`);

  let resposta: Response;
  try {
    resposta = await fetch(`${API_BASE}${caminho}`, { ...opcoes, headers });
  } catch {
    throw new ErroApi(0, 'Sem ligação ao servidor. Verifique a Internet e tente novamente.');
  }

  if (resposta.status === 401) {
    limparToken();
    aoExpirar?.();
    throw new ErroApi(401, 'Sessão expirada. Inicie sessão novamente.');
  }

  const corpo = await resposta.json().catch(() => ({}));
  if (!resposta.ok) {
    throw new ErroApi(resposta.status, (corpo as { erro?: string }).erro ?? 'Ocorreu um erro.');
  }
  return corpo as T;
}

export const obter = <T>(caminho: string) => pedir<T>(caminho);
export const criar = <T>(caminho: string, dados: unknown) =>
  pedir<T>(caminho, { method: 'POST', body: JSON.stringify(dados) });
export const atualizar = <T>(caminho: string, dados: unknown) =>
  pedir<T>(caminho, { method: 'PUT', body: JSON.stringify(dados) });
export const eliminar = <T>(caminho: string) => pedir<T>(caminho, { method: 'DELETE' });

/** Turn a filter object into a query string, dropping empty values. */
export function paraQuery(filtros: Record<string, string | number | undefined | null>): string {
  const params = new URLSearchParams();
  for (const [chave, valor] of Object.entries(filtros)) {
    if (valor !== undefined && valor !== null && valor !== '') params.set(chave, String(valor));
  }
  const texto = params.toString();
  return texto ? `?${texto}` : '';
}
